import { appConfig } from '@config/index.js';

/**
 * Resolves a media or document download URL.
 * If the API returned a URL targeting http://localhost:3001 or http://127.0.0.1:3001,
 * but the app is running in an environment with a custom VITE_API_BASE_URL (such as staging or production),
 * this helper rewrites the localhost origin to match the active API base URL.
 */
export function resolveMediaUrl(url?: string | null): string {
  if (!url) return '';
  const apiBase = appConfig.apiBaseUrl.replace(/\/$/, '');

  if (/^https?:\/\/(localhost|127\.0\.0\.1):3001/i.test(url)) {
    return url.replace(/^https?:\/\/(localhost|127\.0\.0\.1):3001/i, apiBase);
  }

  return url;
}
